import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { forwardRef } from 'react';
import { cx, devWarning } from '@paypalcorp/pp-react-utils';
import { Shimmer } from '@paypalcorp/pp-react-shimmer';
import * as styles from './styles.css';
export { styles as linkStyles };

var _excluded = ["inverse", "secondary", "size", "primaryAlt", "className", "leftIcon", "children", "as", "isLoading"];

// TODO: see if we need to expand this set. Venmo? Xoom? Braintree?
var internalHosts = new Set(['', 'paypal.com', 'paypal.cn', 'gopay.cn']);
var NO_REFERRER = /\bnoreferrer\b/;
var NO_OPENER = /\bnoopener\b/;
var chooseColorScheme = function (isSecondary, isInverse) {
  if (isInverse) {
    return 'inverse';
  }
  return isSecondary ? 'secondary' : 'primary';
};
var Link = forwardRef(function (_ref, ref) {
  var inverse = _ref.inverse,
    secondary = _ref.secondary,
    size = _ref.size,
    primaryAlt = _ref.primaryAlt,
    className = _ref.className,
    leftIcon = _ref.leftIcon,
    children = _ref.children,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'a' : _ref$as,
    isLoading = _ref.isLoading,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (isLoading) {
    return /*#__PURE__*/React.createElement(Shimmer, _extends({
      className: cx(styles.shimmer, className),
      hasStyleDefaults: false,
      isInverse: inverse
    }, rest, {
      "data-ppui": "true"
    }), children);
  }
  var isInternalUrl = function (urlStr) {
    try {
      var url = new URL(urlStr);
      return internalHosts.has(url.hostname);
    } catch (e) {
      devWarning("isInternalUrl('".concat(urlStr, "'}) failed to parse: ").concat(e));
    }
    return false;
  };
  var checkForUnsafe = function (urlStr, rel) {
    if (!(NO_REFERRER.test(rel) && NO_OPENER.test(rel) || isInternalUrl(urlStr))) {
      devWarning("WARNING! '".concat(urlStr, "'\nOpening 3rd party URL in a new window/tab without setting rel to \"noreferrer noopener\" is potentially unsafe."));
    }
  };
  var linkTarget = rest.target,
    _rest$rel = rest.rel,
    rel = _rest$rel === void 0 ? null : _rest$rel,
    _rest$href = rest.href,
    href = _rest$href === void 0 ? '/' : _rest$href;
  if (as === 'a' && (linkTarget === null || linkTarget === void 0 ? void 0 : linkTarget.trim())) {
    var _rel;
    if (!((_rel = rel) === null || _rel === void 0 ? void 0 : _rel.trim())) {
      rel = 'noreferrer noopener';
    } else {
      checkForUnsafe(href, rel);
    }
  }
  var leftIconElement = /*#__PURE__*/React.createElement("span", {
    className: styles.leftIcon,
    "data-ppui": "true"
  }, leftIcon);
  var colorScheme = chooseColorScheme(primaryAlt || secondary, inverse);
  var linkClasses = cx(styles.base, styles[colorScheme], leftIcon && styles.baseIcon, leftIcon && size === 'sm' && styles.baseSmIcon, size === 'sm' ? styles.linkSm : styles.linkLg, className);
  return /*#__PURE__*/React.createElement(as, _extends({
    className: linkClasses,
    ref: ref,
    "data-ppui-info": "links_5.1.2__8.12.0",
    target: linkTarget,
    rel: rel
  }, rest), leftIcon && leftIconElement, children);
});

export { Link };
